<template>
  <div class="welfare wrapW">
    <img class="welfareF" src="~@/assets/img/welfareF.png">
    <div class="Wdescribe">供应链资源合作输出模式</div>
    <div class="shu"></div>
    <div class="shu_xian"></div>
    <div class="center" v-if="list[0]">
      <ul>
        <li>
          <img src="~@/assets/img/welfareF1.png">
          <p class="name">{{list[0].name}}</p>
        </li>
        <li v-html="list[0].desc">
        </li>
      </ul>
      <ul>
        <li>
          <img src="~@/assets/img/welfareF2.png">
          <p class="name">{{list[1].name}}</p>
        </li>
        <li v-html="list[1].desc">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welfareO',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getSupply()
  },
  methods: {
    getSupply () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getSupply', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res.list.output
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.welfare
  text-align center
  padding .69rem 0
  .welfareF
    height .23rem
  .Wdescribe
    font-size .24rem
    margin-top .22rem
    color #666
    letter-spacing .04rem
  .shu
    width 1px
    height .5rem
    background #BBBBBB
    margin 0 auto
    margin-top .2rem
  .shu_xian
    width 4.68rem
    height .5rem
    border 1px solid #BBBBBB
    border-bottom 0px
    margin 0 auto
  .center
    display flex
    justify-content center
    ul
      width 3.07rem
      .name
        border 0
        color #fff
      >>>p
        padding .25rem
        color #3B3B3B
        font-size .16rem
        border 1px solid #BBBBBB
        border-top 0px
        img
          margin-bottom .2rem
      li:first-child
        background #D5A14E
        padding .17rem
        font-size .18rem
        color #fff
        border-top 1px solid #BBBBBB
    ul:first-child
      margin-right 1.58rem
</style>



// WEBPACK FOOTER //
// src/pages/index/components/welfareF.vue